import { ComponentRef, TPAComponentType } from '@wix/editor-platform-sdk-types';
import { EditorAppContext } from './types';
import { harmonySearchWidgetId } from './constants/componentIds';

export async function addSearchWidget(
  appContext: EditorAppContext,
): Promise<ComponentRef | undefined> {
  const { editorSDK, appDefinitionId, reportError } = appContext;
  try {
    const { compId } = await editorSDK.tpa.add.component(appDefinitionId, {
      componentType: TPAComponentType.Widget,
      appDefinitionId,
      widget: {
        widgetId: harmonySearchWidgetId,
        shouldNavigate: false,
      },
    });
    return { id: compId, type: 'DESKTOP' } as ComponentRef;
  } catch (error) {
    reportError(error);
    return undefined;
  }
}
